export default __webpack_public_path__ + "static/media/PresidentBox.17a3377e.jpg";